import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import WechatAuth from '@/components/WechatAuth'
import { Dialog, Toast } from "vant";
import { getCompanyBookedList, updateCancelCompany } from '@/api/module/user';
import { getConsentFormCount as _getConsentFormCount, getQueueregistByPatientid } from "@/api/module";
export default {
  name: "index",
  // extends:WechatAuth,
  data: function data() {
    return {
      active: 5,
      companys: [],
      showMoney: window.g.VUE_APP_SHOW_MONEY,
      VUE_APP_HIDE_MONEY_COMPANYIDS: window.g.VUE_APP_HIDE_MONEY_COMPANYIDS,
      noDataShow: false,
      goAnswerPopShow: window.g.VUE_APP_GO_ANSWER_POP_SHOW,
      // 控制是否显示前往答题的弹框
      answerShow: false,
      // 需要答题的个数
      tipsTile: '',
      tipsText: '',
      task: 0 // 待办任务数量

    };
  },
  created: function created() {
    this.getList();
    this.getConsentFormCount();
    localStorage.removeItem('topath');
  },
  filters: {
    filterDatetime: function filterDatetime(val) {
      return val.substring(0, 10);
    }
  },
  methods: {
    //计算showMoney的值
    getsingleShowMoney: function getsingleShowMoney(companyID) {
      var singleShowMoney = true;

      if (this.showMoney) {
        if (Array.isArray(this.VUE_APP_HIDE_MONEY_COMPANYIDS)) {
          if (companyID != undefined && this.VUE_APP_HIDE_MONEY_COMPANYIDS.includes(companyID.substring(0, 4))) {
            singleShowMoney = false;
          }
        }
      }

      return singleShowMoney;
    },
    getList: function getList() {
      var _this2 = this;

      var user = JSON.parse(localStorage.getItem("loginuser"));
      var param = {
        patientId: user.patientid
      };
      getCompanyBookedList(param).then(function (res) {
        _this2.noDataShow = true;

        if (res.code == 200) {
          _this2.companys = res.data;
        } else {
          Toast.fail(res.msg);
        }
      });
    },
    //2024-03-12 ZLS  新增获取待办任务的数量
    getConsentFormCount: function getConsentFormCount() {
      var _this3 = this;

      var loginuser = JSON.parse(localStorage.getItem("loginuser"));

      if (loginuser == null) {
        return;
      }

      var param = {
        patientid: loginuser.patientid
      };

      _getConsentFormCount(param).then(function (res) {
        if (res.code == 200 && res.data > 0) {
          _this3.task = res.data;
        }
      });
    },
    toOrder: function toOrder(item) {
      this.$router.push({
        name: 'companyOrder',
        query: {
          item: JSON.stringify(item)
        }
      });
    },
    toOrderUpdateDate: function toOrderUpdateDate(item) {
      this.$router.push({
        name: 'companyOrderUpdateDate',
        query: {
          item: JSON.stringify(item)
        }
      });
    },
    toDetail: function toDetail(item) {
      console.log(item.bookedNo, item.settlementMode, item.status, item.orderNo);
      this.$router.push({
        name: 'orderDetail',
        query: {
          bookedno: item.bookedNo,
          settlement: item.settlementMode,
          status: item.status,
          orderno: item.orderNo,
          companyid: item.companyID
        }
      });
    },
    done: function done() {
      Dialog.alert({
        title: '提示',
        message: '已完成此次预约'
      }).then(function () {});
    },
    toHome: function toHome() {
      this.$router.push({
        name: 'home'
      });
    },
    toUserinfo: function toUserinfo() {
      this.$router.push({
        name: 'userinfo'
      });
    },
    toOrders: function toOrders() {
      this.$router.push({
        name: 'orders'
      });
    },
    toTask: function toTask() {
      this.$router.push({
        name: 'letterConsent'
      });
    },
    filterCheckDate: function filterCheckDate(datestr) {
      var char = "-";
      var nowDate = new Date(datestr);
      var day = nowDate.getDate();
      var month = nowDate.getMonth() + 1; //注意月份需要+1

      var year = nowDate.getFullYear(); //补全0，并拼接

      console.log(year + char + this.completeDate(month) + char + this.completeDate(day));
      return year + char + this.completeDate(month) + char + this.completeDate(day);
    },
    getNow: function getNow() {
      var char = "-";
      var nowDate = new Date();
      var day = nowDate.getDate();
      var month = nowDate.getMonth() + 1; //注意月份需要+1

      var year = nowDate.getFullYear(); //补全0，并拼接

      console.log(year + char + this.completeDate(month) + char + this.completeDate(day));
      return year + char + this.completeDate(month) + char + this.completeDate(day);
    },
    //补全0
    completeDate: function completeDate(value) {
      return value < 10 ? "0" + value : value;
    },
    //取消预约
    del: function del(item) {
      var _this4 = this;

      //取消确认
      Dialog.confirm({
        title: '取消确认',
        message: '确认取消预约吗？'
      }).then(function () {
        // on confirm
        var user = JSON.parse(localStorage.getItem("loginuser"));
        var _this = _this4;
        var param = {
          bookedtype: item.bookedType,
          patientid: user.patientid,
          bookedno: item.bookedNo,
          checkdate: item.checkDate,
          sexid: item.sexID,
          companyid: item.companyID,
          companytime: item.companyTime,
          timeslot: item.timeSlot,
          bookednos: item.bookedNos,
          enterqueue: item.enterQueue,
          institutionid: window.g.VUE_APP_INSTITUTIONID
        };
        updateCancelCompany(param).then(function (res) {
          if (res.code == 200) {
            if (res.data == 0) {
              Toast.fail(res.msg);
            } else {
              Toast(res.msg);
              setTimeout(function () {
                _this.getList();
              }, 1000);
            }
          }
        });
      }).catch(function () {// on cancel
      });
    },
    dialogMemo: function dialogMemo(memoTxt) {
      Dialog.alert({
        message: memoTxt
      }).then(function () {// on close
      });
    }
  }
};